<template>
  <b-table-simple small caption-top responsive class="text-center mt-2 mb-0" data-component="km-offline-status-schema">
    <b-thead>
      <b-tr>
        <b-th>
          <div class="caption" :class="`text-`+laptopVariant">KMOffline</div>
          <b-icon-laptop :scale="iconScale" :variant="laptopVariant"/>
        </b-th>
        <b-th style="width:10px;">
          <img v-if="internetOk" src="@/assets/link-ok.svg"/>
          <img v-else src="@/assets/link-broken.svg"/>
        </b-th>
        <b-th>
          <div class="caption" :class="`text-`+internetVariant">internet</div>
          <b-icon-cloud :scale="iconScale" :variant="internetVariant"/>
        </b-th>
        <b-th style="width:10px;">
            <img v-if="hserviceOk" src="@/assets/link-ok.svg"/>
            <img v-else src="@/assets/link-broken.svg"/>
        </b-th>
        <b-th>
          <div class="caption" :class="`text-`+serverVariant">skd online</div>
          <b-icon-server :scale="iconScale" :variant="serverVariant"/>
        </b-th>
      </b-tr>
    </b-thead>
  </b-table-simple>
</template>

<script>
//---- components ---------
//---- mixins -------------
import KmOfflineStatusMixin from "./KmOfflineStatusMixin.js"
//---- services -----------
//---- other --------------
//---- 3rd-parties --------
import {
  BIconCloud,
  BIconLaptop,
  BIconServer,
} from "bootstrap-vue";

/**
 * This component renders a schema showing the connectivity status of KMOffline.
 * 
 * It displays 3 icons (kmoffline, internet and skd online) along with the 
 * connectivity status between each of these links.
 */
export default {

  name: "km-offline-status-schema",

  props: ["stage"],
  
  components: {
    BIconCloud,
    BIconLaptop,
    BIconServer,
  },

  mixins: [KmOfflineStatusMixin],

  data() {
    return {
      iconScale: 1.3,
    }
  },

  computed: {

    hserviceOk() {
      return !this.isKMOffline || this.hServiceConnectivity;
    },

    internetOk() {
      return !this.isKMOffline || this.backendInternetConnectivity;
    },

    connectivityOk() {
      return this.hserviceOk && this.internetOk;
    },

    //---------------------------------------------------

    laptopVariant() {
      return this.stage == 'laptop' ? 'primary' : '';
    },
    internetVariant() {
      return this.internetOk ? "" : "disabled";
    },
    serverVariant() {
      return this.stage == 'server' ? 'primary' : (this.internetOk && this.hserviceOk ? "" : "disabled");
    },

  }, // end computed

};
</script>

<style scoped>

  .text-disabled {
    color: #cccccc;
  }

  .caption {
    font-weight: 400;
    font-size: .8rem;
    line-height: .8rem;
    padding-bottom: .2rem;
  }

</style>